import axios from 'axios';
import { IonTitle, IonButtons, IonButton } from '@ionic/react';
import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Backdrop from '@material-ui/core/Backdrop';
import { IonPopover } from '@ionic/react';
import { IonImg, IonList, IonItem, IonLabel } from '@ionic/react';
import KeyboardArrowDown from '@material-ui/icons/ExpandMore';
import {
  AppBar,
  BottomNavigation,
  BottomNavigationAction,
  Button,
  Popover,
  TextField,
  Toolbar,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './Header.scss';
import Modal from '../Modal/Modal';
import LoginForm from '../LoginForm/LoginForm';
import { RootState } from '../../models/RootState';
import {
  fetchBalance,
  logout,
  fetchBettingCurrency,
  setEventType,
} from '../../store';
import {
  CASINO_USER_PROFILE_NAV_LIST,
  PROFILE_NAV_LIST,
} from '../../constants/DrawerItems';
import {
  getCurrencyTypeFromToken,
  getRoleFromToken,
} from '../../store/auth/authActions';
import webtitleImg from '../../assets/images/brand/title.png';
import mobtitleImg from '../../assets/images/brand/title.png';
import { AuthResponse } from '../../models/api/AuthResponse';
import API from '../../api/index';
import { Currency } from '../../models/Currency';
import BetsListPopper from '../BetsListPopper/BetsListPopper';
import moment from 'moment';
import { useInterval } from '../../hooks/useInterval';
import {
  EXCHANGE_EVENT_TYPES,
  EXCH_SPORTS_MAP,
} from '../../constants/ExchangeEventTypes';
import userAvatar from '../../assets/images/img_avatar.png';
import WalletImg from '../../assets/images/icons/wallet.png';
import { SelectedObj } from '../../models/ExchangeSportsState';
import ChangePwdForm from '../ChangePassword/ChangePassword';
import SelectSearch from 'react-select-search';
import { demoUserPrefix, getSportIdByName } from '../../util/stringUtil';
import { isMobile } from 'react-device-detect';
import { ALLOW_CASINO } from '../../constants/CasinoPermission';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { BRAND_NAME, PROVIDER_ID } from '../../constants/Branding';
import { setAlertMsg, setLangData, setLangSelected, setLanguages } from '../../store/common/commonActions';
import LANG_API from '../../models/api/language-api';
import { getLangCode } from '../../util/localizationUtil';
import { AlertDTO } from '../../models/Alert';
import {
  ShowSelfRagistration,
  ShowWhatsopIcon,
  WHDetails,
} from '../../constants/WhitelabelConfig';
import WhatsupImg from '../../assets/images/footer/whatsup-flot.png';
import SVLS_API from '../../svls-api';
import { Autocomplete } from '@material-ui/lab';
import { EventDTO } from '../../models/common/EventDTO';

type StoreProps = {
  balance: number;
  exposure: number;
  allowedConfig: number;
  commissionEnabled: boolean;
  fetchBalance: Function;
  loggedIn: boolean;
  logout: Function;
  fetchBettingCurrency: Function;
  bettingCurrency: Currency;
  currenciesAllowed: number;
  tvGamesEnabled: boolean;
  setEventType: (eventTypes: SelectedObj) => void;
  
  languages: string[];
  langSelected: string;
  setLangSelected: (lang: string) => void;
  langData: any;
};

type options = [{ name: string; value: string }];
const Header: React.FC<StoreProps> = (props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const history = useHistory();
  const [modalTitle, setModalTitle] = useState('Login');
  const [username, setUsername] = useState<string>('');
  const [searchName, setSearchName] = useState<string>('');
  const [eventsList, setEventsList] = useState([]);
  const [showPopover, setShowPopover] = useState<{
    open: boolean;
    event: Event | undefined;
  }>({
    open: false,
    event: undefined,
  });
  const [showBetsListPopover, setShowBetsListPopover] = useState<{
    open: boolean;
    event: HTMLElement | undefined;
  }>({
    open: false,
    event: undefined,
  });
  const [localTime, setLocalTime] = useState(moment().format('hh:mm:ss A'));
  const {
    balance,
    exposure,
    allowedConfig,
    fetchBalance,
    loggedIn,
    logout,
    fetchBettingCurrency,
    bettingCurrency,
    currenciesAllowed,
    tvGamesEnabled,
    commissionEnabled,
    setEventType,
    languages,
    langSelected,
    setLangSelected,
    langData,
  } = props;

  const [pointsType, setPointsType] = useState<Currency>();
  const [changePwdMOdal, setChangePwdMOdal] = useState<boolean>(false);
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const loggedInUsername = sessionStorage.getItem('username');

  const excheventsList = EXCHANGE_EVENT_TYPES;
  const location = useLocation();
  const handleLangChange = (langParam: string) => {
    sessionStorage.setItem('lang', langParam);
    setLangSelected(sessionStorage.getItem('lang'));
    window.location.reload();
  };
  useEffect(() => {
    if (loggedIn) {
      fetchBalance();
      fetchBettingCurrency();
    }
  }, [fetchBalance, loggedIn, fetchBettingCurrency]);

  useEffect(() => {
    setEventsList(null);
    setShowSearch(false);
    setUsername('');
    setSearchName('');
  }, [location]);

  useInterval(() => {
    if (loggedIn) {
      setLocalTime(moment().format('hh:mm:ss A'));
    }
  }, 1000);

  const loginHandler = () => {
    history.push('/login');
    // setModalOpen(true);
    // setModalTitle('Login');
    // setShowPopover({ open: false, event: undefined });
  };

  const changeBettingCurrency = useCallback(
    async (currency: Currency) => {
      try {
        const response: AuthResponse = await API.put(
          '/user/betting-currency',
          { currency: currency },
          {
            headers: {
              Authorization: sessionStorage.getItem('jwt_token'),
            },
            responseType: 'text',
          }
        );
        if (response.status === 200) {
          fetchBettingCurrency();
          fetchBalance();
        } else {
          throw new Error(response.data);
        }
      } catch (err) {}
    },
    [fetchBalance, fetchBettingCurrency]
  );

  const modalCloseHandler = () => {
    setModalOpen(false);
  };

  const handlePopoverClose = () => {
    setShowPopover({ open: false, event: undefined });
  };

  const logoutHandler = () => {
    logout();
    setShowPopover({ open: false, event: undefined });
  };

  const popoverDismissHandler = () => {
    setShowPopover({ open: false, event: undefined });
  };

  // const searchHandler = async (query: string) => {
  //   const from = moment();
  //   const toDate = moment().add(2, 'd');
  //   const url = '/catalog/v2/sports-feed/sports/live-events:search';

  //   const params = {
  //     searchString: searchName.toLowerCase(),
  //     startDate: from.startOf('day').toISOString(),
  //     endDate: toDate.startOf('day').toISOString(),
  //   };
  //   let response;
  //   if (sessionStorage.getItem('jwt_token')) {
  //     response = await SVLS_API.get(url, {
  //       headers: {
  //         Authorization: sessionStorage.getItem('jwt_token'),
  //       },
  //       params: {
  //         providerId: PROVIDER_ID,
  //         query: query,
  //       },
  //     });
  //   } else {
  //     response = await API.post(
  //       url,
  //       {},
  //       {
  //         params: params,
  //       }
  //     );
  //   }

  //   let newOps: options = [{ name: '', value: '' }];
  //   newOps.pop();
  //   response.data.map((m) =>
  //     newOps.push({
  //       name: m.eventName,
  //       value: `${m.sportId}*${m.eventId}*${m.eventName}*${m.competitionId}*${m.competitionName}`,
  //     })
  //   );

  //   setEventsList(newOps);
  // };

  const searchHandler = async (val) => {
    console.log(val)
    const response = await SVLS_API.get('/catalog/v2/sports-feed/sports/events:search',
        {
            headers: {
                Authorization: sessionStorage.getItem('jwt_token'),
            },
            params: {
                providerId: PROVIDER_ID,
                query: val,
            },
        }
    );
    if (response.status == 200) {
      const resp = response.data.map((item) => {
        return {
          name: item?.eventName,
          value: {
            name: item?.eventName,
            sportName: item?.sportName,
            competitionName: item?.competitionName,
            sportId: item?.sportId,
            competitionId: item?.competitionId,
            eventId: item?.eventId
          }
        }
      })
      setEventsList(resp);
    }
}

  useEffect(() => {
    if (searchName.length > 2) {
      searchHandler(searchName);
    }
  }, [searchName]);

  const handleEventSearch = (newEvent: any) => {
    history.push(
      `/exchange_sports/${getCompetitionSlug(
        newEvent?.sportName
      )}/${getCompetitionSlug(
        newEvent?.competitionName
      )}/${getCompetitionSlug(newEvent?.name)}/${btoa(
        `${newEvent?.sportId}:${newEvent?.competitionId}:${newEvent?.eventId}`
      )}`
      
    );

    // reset search control
    setEventsList(null);
    setShowSearch(false);
    setUsername('');
    setSearchName('');
  };
  const signupHandler = () => {
    history.push('/register');
  };

  const getCompetitionSlug = (competitionName: string) => {
    return competitionName
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]/g, ' ')
      .replace(/ +/g, ' ')
      .trim()
      .split(' ')
      .join('-');
  };

  return (
    <>
      <AppBar
        position="static"
        className={
          history.location.pathname.startsWith('/casino') ||
          (history.location.pathname.startsWith('/poker') && isMobile)
            ? 'hidden-header main-header-ctn ds-view-ctn mob-header-ctn'
            : 'main-header-ctn ds-view-ctn mob-header-ctn'
        }
      >
        <Toolbar className="header-toolbar">
          <div className="tool-bar-content">
            <IonButtons slot="start">
              <IonTitle
                class="icon-title"
                slot="start"
                size="small"
                onClick={() => history.push('/home')}
              >
                <IonImg className="web-logo" src={webtitleImg} />
                <IonImg className="mob-logo" src={mobtitleImg} />
              </IonTitle>
              {loggedIn ? (
                <div className="live-clock">
                  <div className="date">{moment().format('MMM D, YYYY')}</div>
                  <div className="time">{localTime}</div>
                </div>
              ) : null}
            </IonButtons>

            <IonButtons
              className={`nav-btns ${
                loggedIn && getRoleFromToken() && getRoleFromToken() !== 'User'
                  ? 'admin-header'
                  : ''
              }`}
            >
              {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
                <>
                  <NavLink
                    activeClassName="active in-play-active"
                    to="/exchange_sports/inplay"
                    className="nav-link"
                  >
                    <IonButton className="nav-link-btn" color="">
                      {langData?.['in_play']}
                    </IonButton>
                  </NavLink>
                  <NavLink
                    activeClassName="active cricket-active"
                    to="/exchange_sports/cricket"
                    className="nav-link"
                  >
                    <IonButton className="nav-link-btn" color="">
                      {langData?.['sports']}
                    </IonButton>
                  </NavLink>
                </>
              ) : null}

              {(allowedConfig & CONFIG_PERMISSIONS.live_casino) !== 0 ? (
                <NavLink
                  activeClassName="active live-casino-active"
                  to="/virtual_sports"
                  className="nav-link"
                >
                  {/* <IonButton className="nav-link-btn" color="">
                    Virtual Cricket
                  </IonButton> */}
                </NavLink>
              ) : null}

              {(allowedConfig & CONFIG_PERMISSIONS.live_casino) !== 0 ? (
                <NavLink
                  activeClassName="active live-casino-active"
                  to="/casino"
                  className="nav-link"
                >
                  <IonButton className="nav-link-btn" color="">
                    {langData?.['live_casino']}
                  </IonButton>
                </NavLink>
              ) : null}
            </IonButtons>

            {loggedIn && showSearch ? (
              <div className="event-search search-col">
                <SelectSearch
                  search
                  getOptions={(query) => {
                    return new Promise((resolve, reject) => {
                      setSearchName(query);
                    });
                  }}
                  onChange={handleEventSearch}
                  placeholder="Search event"
                  options={eventsList}
                  value={searchName}
                ></SelectSearch>

                <span
                  className="clear-search"
                  onClick={() => {
                    setUsername('');
                    setSearchName('');
                    setShowSearch(false);
                  }}
                >
                  <CloseIcon className="close-icon m-link" />
                </span>
              </div>
            ) : null}
            <IonButtons className="right-side-actions" slot="end">
              {ShowWhatsopIcon[BRAND_NAME.toLocaleLowerCase()] ? (
                <IonButton className="actions-btn whatsapp-btn">
                  <div className="btn-content">
                    <a
                      href={`http://api.whatsapp.com/send?phone=${
                        WHDetails[BRAND_NAME.toLocaleLowerCase()]?.whatsapp
                      }`}
                      target="_blank"
                    >
                      <img src={WhatsupImg} className="social-icon1" />
                    </a>
                  </div>
                </IonButton>
              ) : null}
               <div className="changeLanguage">
                    {languages.length > 0 && (
                      <div className="lang-select-menu">
                        <div className="lang-select">
                          <div className="lang">
                            {getLangCode(langSelected)}
                          </div>
                          <KeyboardArrowDown className="dropdown-icon" />
                        </div>
                        <div className="lang-menu">
                          {languages.map((language) => (
                            <div
                              key={language} // Don't forget the key prop!
                              className={`lang-menu-option ${
                                langSelected === language ? 'selected' : ''
                              }`}
                              onClick={() => handleLangChange(language)}
                            >
                             {language.replace('(', ' (')}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
              {loggedIn ? (
                <>
                  {showSearch ? null : (
                    <>
                      {window.location.pathname.includes('exchange_sports') &&
                      !window.location.pathname.endsWith(
                        'exchange_sports/binary'
                      ) ? (
                        <IonButtons
                          className="m-link search-icon-ctn"
                          onClick={() => setShowSearch(true)}
                        >
                          <SearchIcon className="search-icon" />
                        </IonButtons>
                      ) : null}

                      <IonButton
                        onClick={(e) => {
                          setShowBetsListPopover({
                            open: true,
                            event: e.currentTarget,
                          });
                        }}
                        className="my-bets-btn actions-btn"
                      >
                        <div className="btn-content">
                          <div className="btn-header">
                            {' '}
                            {langData?.['my_bets']}
                          </div>
                          <div className="exposure-details">
                            {langData?.['header_exp_txt']}:{' '}
                            {exposure !== null
                              ? Number(exposure / cFactor).toFixed(2)
                              : '-.--'}
                          </div>
                        </div>
                      </IonButton>
                      <IonButton
                        className="user-acc-btn actions-btn"
                        onClick={(e) => {
                          if (!isMobile)
                            setShowPopover({
                              open: true,
                              event: e.nativeEvent,
                            });
                          else history.push('/dashboard');
                        }}
                      >
                        <IonImg
                          className="user-avatar"
                          src={userAvatar}
                          alt="user"
                        />
                        <div className="btn-content">
                          <div className="btn-header">
                          {loggedInUsername?.startsWith(demoUserPrefix)
                            ? 'Demo User'
                            : loggedInUsername}
                          </div>
                          <div className="balance-details">
                            {langData?.['header_balance_txt']}:{' '}
                            {balance !== null
                              ? Number(balance / cFactor).toFixed(2)
                              : '-.--'}
                          </div>
                        </div>
                        {isMobile ? null : <KeyboardArrowDown />}
                      </IonButton>

                      <IonButton className="user-acc-btn actions-btn mob-actions-btn">
                        <IonImg
                          className="wallet-icon"
                          src={WalletImg}
                          alt="wallet"
                        />
                        <div
                          className="btn-content-mob"
                          onClick={(e) => {
                            setShowBetsListPopover({
                              open: true,
                              event: e.currentTarget,
                            });
                          }}
                        >
                          <div className="balance-details-mob">
                            {langData?.['header_balance_txt']}:{' '}
                            {Number(balance).toFixed(2)}
                          </div>
                          <div className="exposure-details-mob">
                            {langData?.['header_exp_txt']}:{' '}
                            {Number(exposure).toFixed(2)}
                          </div>
                        </div>

                        <IonImg
                          onClick={(e) =>
                            setShowPopover({ open: true, event: e.nativeEvent })
                          }
                          className="user-avatar"
                          src={userAvatar}
                          alt="user"
                        />
                        <KeyboardArrowDown
                          onClick={(e) =>
                            setShowPopover({ open: true, event: e.nativeEvent })
                          }
                        />
                      </IonButton>
                    </>
                  )}
                </>
              ) : (
                <IonButtons slot="secondary">
                  {ShowSelfRagistration[BRAND_NAME.toLocaleLowerCase()] ? (
                    <IonButton
                      slot="end"
                      className="signup-btn"
                      onClick={signupHandler}
                      fill="solid"
                      color="primary"
                    >
                      {langData?.['sign_up']}
                    </IonButton>
                  ) : null}
                  <IonButton
                    slot="end"
                    className="login-btn"
                    onClick={loginHandler}
                    fill="solid"
                    color="primary"
                  >
                    {langData?.['login']}
                  </IonButton>
                </IonButtons>
              )}
            </IonButtons>
          </div>
        </Toolbar>
      </AppBar>

      <IonPopover
        isOpen={showPopover.open}
        event={showPopover.event}
        mode="ios"
        onDidDismiss={() => popoverDismissHandler()}
        cssClass={
          currenciesAllowed === 2
            ? 'user-menu-popover extra-width'
            : 'user-menu-popover'
        }
      >
        <div className="user-popover">
          <IonList lines="none" class="user-popover-list">
            <IonItem className="ion-list-item profile-item">
              <div slot="start">
                <NavLink
                  activeClassName="active"
                  className="nav-link"
                  to="/profile"
                  onClick={handlePopoverClose}
                >
                  <div className="profile-link">
                    {loggedInUsername?.startsWith(demoUserPrefix)
                      ? 'Demo User'
                      : loggedInUsername}
                  </div>
                </NavLink>
                <div className="balance">
                  {balance !== null
                    ? parseFloat((balance / cFactor).toString()).toFixed(2)
                    : '-'}
                </div>
              </div>
              <div slot="end">
                {currenciesAllowed === 2 ? (
                  <BottomNavigation
                    value={pointsType ? pointsType : bettingCurrency}
                    onChange={(event, newValue) => {
                      changeBettingCurrency(newValue);
                      setPointsType(newValue);
                    }}
                    showLabels
                    className="header-pointstype-toggle"
                  >
                    <BottomNavigationAction label="PTS" value={Currency.Pts} />
                    <BottomNavigationAction label="HKD" value={Currency.Hkd} />
                  </BottomNavigation>
                ) : null}
              </div>
            </IonItem>

            {allowedConfig & CONFIG_PERMISSIONS.sports ? (
              <>
                {PROFILE_NAV_LIST.map((item, index) => (
                  <NavLink
                    activeClassName="active"
                    className="nav-link"
                    to={item.path}
                    key={index}
                    onClick={handlePopoverClose}
                  >
                    <IonItem className="ion-list-item">
                      <IonLabel>{langData?.[item.langKey]}</IonLabel>
                    </IonItem>
                  </NavLink>
                ))}
              </>
            ) : (
              <>
                {CASINO_USER_PROFILE_NAV_LIST.map((item, index) => (
                  <NavLink
                    activeClassName="active"
                    className="nav-link"
                    to={item.path}
                    key={index}
                    onClick={handlePopoverClose}
                  >
                    <IonItem className="ion-list-item">
                      <IonLabel>{langData?.[item.langKey]}</IonLabel>
                    </IonItem>
                  </NavLink>
                ))}
              </>
            )}

            {ShowSelfRagistration[BRAND_NAME.toLocaleLowerCase()] ? (
              <>
                <NavLink
                  activeClassName="active"
                  className="nav-link"
                  to="/transaction/deposit"
                >
                  <IonItem className="ion-list-item">
                    <IonLabel>{langData?.['deposit']}</IonLabel>
                  </IonItem>
                </NavLink>
                <NavLink
                  activeClassName="active"
                  className="nav-link"
                  to="/transaction/withdraw"
                >
                  <IonItem className="ion-list-item">
                    <IonLabel>{langData?.['withdrawal']}</IonLabel>
                  </IonItem>
                </NavLink>
                <NavLink
                  activeClassName="active"
                  className="nav-link"
                  to="/my_transactions"
                >
                  <IonItem className="ion-list-item">
                    <IonLabel>{langData?.['my_txns']}</IonLabel>
                  </IonItem>
                </NavLink>
              </>
            ) : null}

            {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 &&
            (allowedConfig & CONFIG_PERMISSIONS.commission) !== 0 &&
            commissionEnabled ? (
              <NavLink
                activeClassName="active"
                className="nav-link"
                to="/commission_report"
              >
                <IonItem className="ion-list-item">
                  <IonLabel>{langData?.['commission_report']}</IonLabel>
                </IonItem>
              </NavLink>
            ) : null}

            <NavLink
              activeClassName="active"
              className="nav-link"
              to="/set-button-variables"
              onClick={handlePopoverClose}
            >
              <IonItem className="ion-list-item">
                <IonLabel>{langData?.['set_button_variables']}</IonLabel>
              </IonItem>
            </NavLink>
            {!loggedInUsername?.startsWith(demoUserPrefix) && commissionEnabled ? (
              <NavLink
                activeClassName="active"
                className="nav-link"
                to="/commission_report:upline"
                onClick={handlePopoverClose}
              >
                <IonItem className="ion-list-item">
                  <IonLabel>{langData?.['commission_report']}</IonLabel>
                </IonItem>
              </NavLink>
            ) : null}

            {!loggedInUsername?.startsWith(demoUserPrefix) ? (
              <IonItem
                className="ion-list-item"
                onClick={() => setChangePwdMOdal(true)}
              >
                <IonLabel>{langData?.['change_password_txt']}</IonLabel>
              </IonItem>
            ) : null}
            <IonItem className="ion-list-item" onClick={logoutHandler}>
              <IonLabel>{langData?.['logout']}</IonLabel>
            </IonItem>
          </IonList>
        </div>
      </IonPopover>

      <Popover
        open={showBetsListPopover.open}
        anchorEl={showBetsListPopover.event}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        className="bets-list-popover"
        onClose={() => setShowBetsListPopover({ open: false, event: null })}
      >
        <div className="">
          <BetsListPopper
            closePopover={() =>
              setShowBetsListPopover({ open: false, event: null })
            }
          />
        </div>
      </Popover>

      <Backdrop className="backdrop-ctn" open={modalOpen}>
        <Modal
          open={modalOpen}
          closeHandler={modalCloseHandler}
          title={modalTitle}
          size="xl"
          customClass={'login-modal-ctn'}
        >
          <div className="login-border">
            <LoginForm modalCloseHandler={modalCloseHandler}></LoginForm>
          </div>
        </Modal>
      </Backdrop>

      <Backdrop className="backdrop-ctn" open={changePwdMOdal}>
        <Modal
          open={changePwdMOdal}
          closeHandler={() => setChangePwdMOdal(false)}
          title= {langData?.['change_password_txt']}
          size="xs"
        >
          <ChangePwdForm
            closeHandler={() => setChangePwdMOdal(false)}
            backHandler={() => {}}
          />
        </Modal>
      </Backdrop>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    balance: state.auth.balanceSummary.balance,
    exposure: state.auth.balanceSummary.exposure,
    allowedConfig: state.common.allowedConfig,
    loggedIn: state.auth.loggedIn,
    commissionEnabled: state.common.commissionEnabled,
    bettingCurrency: state.common.bettingCurrency,
    currenciesAllowed: state.common.currenciesAllowed,
    tvGamesEnabled: state.common.tvGamesEnabled,
    langSelected: state.common.langSelected,
    languages: state.common.languages,
    langData: state.common.langData,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchBalance: () => dispatch(fetchBalance()),
    logout: () => dispatch(logout()),
    fetchBettingCurrency: () => dispatch(fetchBettingCurrency()),
    setEventType: (et: SelectedObj) => dispatch(setEventType(et)),
    setLangSelected: (lang: string) => dispatch(setLangSelected(lang)),
    setLanguages: (languages: string[]) => dispatch(setLanguages(languages)),
    setLangData: (langData: any) => dispatch(setLangData(langData)),
    setAlertMsg: (alert: AlertDTO) => dispatch(setAlertMsg(alert)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
